import {observer} from "mobx-react";
import React from "react";

import {WidgetProps} from "controls/designer/features/widgets/widgetProps";
import {DefaultWidgetWrapper} from "controls/designer/features/widgets/defaultWidgetWrapper";
import {Section} from "controls/react/layout/section";
import {anyFlagSet} from "areas/service-boards/widgets/grids/gridToolbarVisibility";
import {Toolbar} from "controls/react/layout/toolbar";
import {RefreshTimer} from "controls/grid/refreshTimer";
import {DataSizeIndicator} from "controls/grid/dataSizeIndicator";
import {GridSearchInput} from "controls/grid/gridSearchInput";
import {ViewSelector} from "controls/grid/viewManager/viewSelector";
import {Grid} from "controls/grid/grid";
import {useStore} from "core/react/useStore";
import {IncidentsGridWidgetStore} from "areas/incidents/widgets/IncidentsGridWidget/store";
import {IncidentsGridWidgetConfig} from "areas/incidents/widgets/IncidentsGridWidget/config";
import {IncidentsGridWidgetPersistedState} from "areas/incidents/widgets/IncidentsGridWidget/persistedState";
import {serialize} from "serializr";


const IncidentsGridWidget = observer(
	class InnerWidget extends React.PureComponent<WidgetProps<IncidentsGridWidgetConfig, IncidentsGridWidgetPersistedState>>{
		store: IncidentsGridWidgetStore;
		constructor(props: WidgetProps<IncidentsGridWidgetConfig, IncidentsGridWidgetPersistedState>) {
			super(props);

			this.store = new IncidentsGridWidgetStore(props)
		}

		render() {

			const gridStore = this.store.incidentsGridStore?.gridStore

			if(!gridStore?.selfInitialized)
				return null

			const editMode = !this.props.dashboardSettings.readOnly
			const flags = this.props.config.gridToolbarVisibility


			return <DefaultWidgetWrapper {...this.props}>
				<Section appearance="none" height={"fit"}>
					{(anyFlagSet(flags) || editMode) &&
						<Toolbar>
							{(flags.showRefreshTimer || editMode)
								&& <RefreshTimer store={gridStore}/>}

							{(flags.showFilters || editMode)
								&& <DataSizeIndicator store={gridStore}/>}

							{(flags.showFilters || editMode)
								&& <GridSearchInput store={gridStore}/>}

							{(flags.showViewSelector || editMode)
								&& <ViewSelector store={gridStore} createViewDisabled={!editMode} editViewDisabled={!editMode}/>}
						</Toolbar>
					}
					<Grid store={gridStore}/>
				</Section>
			</DefaultWidgetWrapper>
		}

		getStateForSaving() {
			return {
				grid: serialize(this.store.incidentsGridStore.gridStore.state)
			};
		}

})

export default IncidentsGridWidget
